import { Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import Message from "../message";

function IIMJobsScraper() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [searchTerm, setSearchTerm] = useState("");
    const [statusInputQuery, setStatusInputQuery] = useState("");

    const submit_inputQuery = async () => {
        setStatusInputQuery("");
        if (searchTerm === "") {
            setStatusInputQuery("Enter URL!");
        }
        else {
            const requestOptions = {
                method: "POST",
                headers: {
                    "accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    url: searchTerm,
                }),
            };
            const requestUrl = apiServer + "api/iimjobs/scrape_jobs";

            try {
                const response = await fetch(
                    requestUrl,
                    requestOptions
                );
                const inputQueryId = await response.json();
                const inputQueryStatus = inputQueryId.detail
                    ? inputQueryId.detail
                    : inputQueryId;
                setStatusInputQuery(inputQueryStatus);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <TextField
                style={{ marginTop: "15px", width: "100%" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)
                }
                id="outlined-basic"
                label="URL"
                variant="filled"
            />
            <br />
            <Button
                variant="primary"
                style={{ marginTop: "20px", width: "100%" }}
                onClick={() => submit_inputQuery()}
            >
                Submit
            </Button>
            {Message(statusInputQuery, setStatusInputQuery)}
        </div>
    );
}

export default IIMJobsScraper;
